'use client';
// Saludo según la hora del visitante. Se calcula en el navegador (la página es
// estática): el servidor entrega «Buenos días» y se ajusta al montar.
import { useEffect, useState } from 'react';

export default function Saludo() {
  const [texto, setTexto] = useState('Buenos días, colega.');
  useEffect(() => {
    const h = new Date().getHours();
    setTexto(h < 12 ? 'Buenos días, colega.' : h < 19 ? 'Buenas tardes, colega.' : 'Buenas noches, colega.');
  }, []);
  return texto;
}
